import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { SkipTrackingProvider, Box } from '@drone-js/core';
import { DayPicker } from './DayPicker.js';
import { MonthPicker } from './MonthPicker.js';
import { useDatePicker } from './useDatePicker.js';
import { YearPicker } from './YearPicker.js';

var _excluded = ["today"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/**
 * Date picker has three variants for displaying the calendar: `single`, `double`, and `scrollable`. Any variant can be used for date range selection or single date selection.
 * Use `monthYearPicker` prop to enable month and year selector
 *
 * Notice: DatePicker component isn't ready to be used at the moment. If you decided to use it, please be mindful
 * that this component is still in development and major changes might be introduced in the future.
 * For responsive web tablet and desktop sized viewport, the user will be able to select a date or date range
 * by viewing one or two months in a popover that adjusts to the width of the calendar contents.
 * On active state of field, the popover will open.
 */
var DatePicker = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$today = _ref.today,
    today = _ref$today === void 0 ? true : _ref$today,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useDatePicker = useDatePicker(_objectSpread({
      today: today
    }, rest)),
    calendarState = _useDatePicker.calendarState,
    dayPickerProps = _useDatePicker.dayPickerProps,
    monthYearPickerProps = _useDatePicker.monthYearPickerProps,
    containerRef = _useDatePicker.containerRef;
  if (!rest.monthYearPicker) {
    return /*#__PURE__*/React.createElement(SkipTrackingProvider, null, /*#__PURE__*/React.createElement(DayPicker, _extends({
      ref: ref
    }, dayPickerProps)));
  }
  return /*#__PURE__*/React.createElement(SkipTrackingProvider, null, /*#__PURE__*/React.createElement(Box, {
    position: "relative",
    ref: containerRef
  },
  /*#__PURE__*/
  /**
  Set the visibility of the DayPicker to hidden when switching to month/year to maintain the DayPicker layout
  and avoid layout shifts when switching between day, month, and year
   */
  React.createElement(Box, {
    visibility: calendarState === 'day' ? 'visible' : 'hidden'
  }, /*#__PURE__*/React.createElement(DayPicker, _extends({
    ref: ref
  }, dayPickerProps))), calendarState === 'month' && /*#__PURE__*/React.createElement(MonthPicker, monthYearPickerProps), calendarState === 'year' && /*#__PURE__*/React.createElement(YearPicker, monthYearPickerProps)));
});
var DatePickerMemoized = /*#__PURE__*/React.memo(DatePicker);
DatePickerMemoized.displayName = 'DatePicker';

export { DatePicker as BaseDatePicker, DatePickerMemoized as DatePicker };
//# sourceMappingURL=DatePicker.js.map
